import httpClient from '@/api/httpClient'

class TinyPngApi {
  static async postCompressor(file) {
    const params = new FormData()
    params.append('file', file)
    const res = await httpClient.post('image/compressor', params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return res.data
  }
}

export default TinyPngApi
